import { IFeatureProps } from 'mod/featureV2/interface';
import { FeatureTextBanner as ModFeatureTextBanner } from 'mod/featureV2/FeatureTextBanner';
import { IFeatureTextBanner } from 'mod/featureV2/interface/textBanner';
import cn from 'classnames';
import styles from './index.module.less';
import bannerStyles from '@pro/feature/FeatureBanner/index.module.less';

export function FeatureTextBanner(props: IFeatureProps<IFeatureTextBanner>): Globals.JSXRenderType {
    return (
        <ModFeatureTextBanner
            className={cn(styles['text-banner'], bannerStyles.banner)}
            {...props}
        />
    )
}

export default FeatureTextBanner;